
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international-patients",
      function () {
        return require("private-next-pages/international-patients.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/international-patients"])
      });
    }
  